import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/translation.json';
import es from './locales/es/translation.json';
import fr from './locales/fr/translation.json';
import it from './locales/it/translation.json';
export const supportedLanguages = ['es', 'en', 'it', 'fr'];
const languageStorageKey = 'aitechcare-language';
const getInitialLanguage = () => {
    const storedLanguage = localStorage.getItem(languageStorageKey);
    if (supportedLanguages.includes(storedLanguage)) {
        return storedLanguage;
    }
    const browserLanguages = navigator.languages?.length ? navigator.languages : [navigator.language];
    const browserLanguage = browserLanguages
        .map((language) => language.split('-')[0])
        .find((language) => supportedLanguages.includes(language));
    if (browserLanguage) {
        return browserLanguage;
    }
    return 'es';
};
void i18n.use(initReactI18next).init({
    resources: {
        es: { translation: es },
        en: { translation: en },
        it: { translation: it },
        fr: { translation: fr }
    },
    lng: getInitialLanguage(),
    fallbackLng: 'es',
    interpolation: {
        prefix: '%{',
        suffix: '}',
        escapeValue: false
    }
});
i18n.on('languageChanged', (language) => {
    if (supportedLanguages.includes(language)) {
        localStorage.setItem(languageStorageKey, language);
        document.documentElement.lang = language;
    }
});
document.documentElement.lang = i18n.language;
export default i18n;
